import { baseUrl } from "../config";

export const getNotificationList = async (pg, pp) => {
    const res = await fetch(`${baseUrl}/labmai/home/rest/common/annlist?current_page=${pg}&page_size=${pp}`);
    return await res.json();
}

export const getNotificationDetail = async (id) => {
    const res = await fetch(`${baseUrl}/labmai/home/ajax/rest/get-ann-content?id=${id}`);
    return await res.json();
}

export const getFileList = async (pg, pp) => {
    const res = await fetch(`${baseUrl}/labmai/home/rest/common/dolist?current_page=${pg}&page_size=${pp}`);
    return await res.json();
}